import {Modal} from "./modal";

/** Компонент открытия модала. */
export class OpenModal {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} button Кнопка, открывающая модал.
     */
    constructor(button) {
        this.button = button;
        this.dataAttr = this.button.dataset.modal;
        this.bindEventListeners();
    }

    /**
     * Прослушиваем события для открытия модала.
     * Если модал открывается на кнопку в бургер-меню, то меню закрываем.
     * Если модал открывается на кнопку внутри другого модала, то первый модал закрываем.
     *
     * @returns {void}
     */
    bindEventListeners() {
        this.button.addEventListener("click", () => {
            const modal = document.querySelector(
                `.js-mch-modal[data-modal-name='${this.dataAttr}']`
            );
            Modal.open(modal);

            if (this.button.closest(".js-mch-burger-menu")) {
                this.button
                    .closest(".js-mch-burger-menu")
                    .classList.remove("is-open");
                document
                    .querySelector(".js-mch-header")
                    .classList.remove("is-menu-open");
            }

            if (this.button.closest(".js-mch-modal")) {
                this.button.closest(".js-mch-modal").classList.remove("shown");
            }
        });
    }
}

document
    .querySelectorAll(".js-mch-open-modal")
    .forEach((button) => new OpenModal(button));
